<template>
  <div class="min-h-screen">
    <slot />
  </div>
</template>
